<template>
  <div class="top-progress-bar-wrapper -helper--flex justify-center">
    <div class="content -helper--flex align-center fluid">
      <span class="main-logo-dark-blue" />
      <div class="progress-bar-wrapper">
        <span :style="{ width: progressBarWidth }" class="bar-fill" />
      </div>
      <span
        v-if="isBackShown"
        @click="handleBack"
        class="top-bar-cta icon-back-btn"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'top-progress-bar',
  props: ['isBackShown', 'prevStep', 'isNewLogo'],
  methods: {
    handleBack () {
      this.$store.commit('onboarding/setKeyValue', {
        prop: 'editMode',
        value: true
      })
      if (this.prevStep) {
        this.$router.push({name: this.prevStep})
      } else {
        this.$router.go(-1)
      }
    }
  },
  computed: {
    progressBarWidth () {
      return this.$store.getters['onboarding/progressBarWidth']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/globalUiComponents/TopProgressController.vue